export const AUTH0_SCOPE = 'openid profile email offline_access';
